import { render, staticRenderFns } from "./alternativeEdu.vue?vue&type=template&id=23b5252f&scoped=true&"
import script from "./alternativeEdu.vue?vue&type=script&lang=js&"
export * from "./alternativeEdu.vue?vue&type=script&lang=js&"
import style0 from "./alternativeEdu.vue?vue&type=style&index=0&id=23b5252f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b5252f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
